import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import { formatBudgetName, removeBudgetWord } from '@/modules/finances/lib';
import type { CumulativeType } from '@/modules/finances/lib/expenses-metric-chart-search-params';
import { getMonthAbbreviationToolTip } from '@/modules/finances/lib/expenses-metric-chart-utils';
import type { GRANULARITY_OPTIONS, LineChartSeries } from '@/modules/finances/types';
import { usLocalizedNumber } from '@/shared/lib/humanization';
interface ExpensesMetricChartTooltipProps {
  filteredParams: LineChartSeries[];
  isMobile: boolean;
  isTablet: boolean;
  isDesktop1024: boolean;
  selectedGranularity: GRANULARITY_OPTIONS;
  isCumulative: boolean;
  cumulativeType: CumulativeType;
  year: string;
}
function ExpensesMetricChartTooltip(t0) {
  const $ = _c(28);
  const {
    filteredParams,
    isMobile,
    isTablet,
    isDesktop1024,
    selectedGranularity,
    isCumulative,
    cumulativeType,
    year
  } = t0;
  const shortAmount = filteredParams.length > 10;
  let t1;
  if ($[0] !== filteredParams[0]?.dataIndex || $[1] !== selectedGranularity || $[2] !== year) {
    t1 = selectedGranularity as string === "Annually" ? year : getMonthAbbreviationToolTip(filteredParams[0]?.dataIndex ?? 0);
    $[0] = filteredParams[0]?.dataIndex;
    $[1] = selectedGranularity;
    $[2] = year;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const title = t1;
  let t2;
  if ($[4] !== title) {
    t2 = <div className="mb-4 text-xs font-semibold text-[#B6BCC2]">{title}</div>;
    $[4] = title;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== cumulativeType || $[7] !== isCumulative) {
    t3 = isCumulative && <div className="text-muted-foreground mb-4 text-[11px] font-light uppercase">{cumulativeType} cumulative</div>;
    $[6] = cumulativeType;
    $[7] = isCumulative;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = shortAmount ? "flex-row flex-wrap gap-4" : "flex-col gap-3";
  const t5 = isTablet ? "max-w-80" : isDesktop1024 ? "max-w-96" : "max-w-md min-w-48";
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = cn("flex", t4, t5);
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== filteredParams || $[13] !== isDesktop1024 || $[14] !== isMobile || $[15] !== isTablet) {
    let t8;
    if ($[17] !== isDesktop1024 || $[18] !== isMobile || $[19] !== isTablet) {
      t8 = item => <div key={`${item.seriesName}-${item.value}`} className="flex items-center gap-1.5"><svg xmlns="http://www.w3.org/2000/svg" width={isMobile ? 13 : 16} height={isMobile ? 13 : 16} viewBox="0 0 13 13" fill="none" className="shrink-0"><circle cx="6.5" cy="6.5" r="5.5" stroke={item.color} /><circle cx="6.5" cy="6.5" r="4" fill={item.color} /></svg><span className={cn("text-muted-foreground inline-block truncate text-sm whitespace-nowrap", isTablet ? "max-w-48" : isDesktop1024 ? "max-w-md" : undefined)}>{removeBudgetWord(formatBudgetName(item.seriesName))}:</span><span className="text-foreground inline-block text-base font-bold">{usLocalizedNumber(item.value, 2)}</span></div>;
      $[17] = isDesktop1024;
      $[18] = isMobile;
      $[19] = isTablet;
      $[20] = t8;
    } else {
      t8 = $[20];
    }
    t7 = [...filteredParams].reverse().map(t8);
    $[12] = filteredParams;
    $[13] = isDesktop1024;
    $[14] = isMobile;
    $[15] = isTablet;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  let t8;
  if ($[21] !== t6 || $[22] !== t7) {
    t8 = <div className={t6}>{t7}</div>;
    $[21] = t6;
    $[22] = t7;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== t2 || $[25] !== t3 || $[26] !== t8) {
    t9 = <div className="bg-card rounded-xl p-4 shadow-md">{t2}{t3}{t8}</div>;
    $[24] = t2;
    $[25] = t3;
    $[26] = t8;
    $[27] = t9;
  } else {
    t9 = $[27];
  }
  return t9;
}
export { ExpensesMetricChartTooltip };